<style>
  .Secondary_Action {
    margin: 2rem;
    width: 230px;
    height: 130px;
    position: relative;
  }

  .Secondary_Action img {
    height: 100%;
    width: auto;
    padding: 0;
    margin: 0;
  }

  .delete-img {
    position: absolute;
    top: -10px;
    left: -18px;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    z-index: 1000;
    background: rgba(192, 39, 39, 0.61);
    color: rgb(218, 218, 218);
    padding-top: 5px;
    box-sizing: border-box;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  .Secondary_Action {
    background-color: rgb(230, 230, 230);
  }
</style>

<script>
  import ButtonPopupImg from "../components/shared/buttons/ButtonPopupImg.svelte"
  import {getToken} from "../js-core/conn/auth/auth-main"
  import {BSGet, BSPatch} from "../js-core/conn/reqs"
  import GeneralImg from "../components/shared/img/GeneralImg.svelte"
  import { Col, Container, Row } from "sveltestrap";

  export let params
  
  let totalSpots, openSpots, approved = {}, allAdsAndDummies = [], allAds = [], loading
  const getBidsProm = getBids()
  async function getBids() {
    const res = await BSGet("tv-owner/get-upcoming-ads")
    if (res.status === 200) {
      const resBody = await res.json();
      allAds = resBody.response.ads
      openSpots = resBody.response.openSpots
      totalSpots = resBody.response.totalSpots
      allAdsAndDummies = Array(totalSpots).fill(null)
      allAds.forEach((ad, i) => allAdsAndDummies[i] = ad)
      return resBody.response.ads
    } else {
      throw {message: "There was an error getting your getting your spots"}
    }
  }

  function navigateToNewAnnouncement(spotNumber) {
    window.location.href = `#/brite-host/${params.group}/new-announcement/${spotNumber}`
  }

  async function changeAnnouncementEndTime(adId, newDate) {
    const res = await BSPatch(`tv-owner/${adId}/experation-date`, JSON.stringify({ newDate }))
    if (res.status === 200) {
      window.location.reload()
    } else {
      alert("There was an error changing your announcement's end time. Please try again")
    }
  }
</script>

<div class="Page_Title" style="padding: 0;">
  <span>Manage Spots</span>
</div>
{#await getBidsProm}
  <p>Loading your information...</p>
{:then ads}
  <!-- <div class="Page_Title">
      <span style="font-size: 25px; font-weight: bold;">Spots Open: {openSpots}/{totalSpots}</span>
  </div> -->
  <Container>
    <Row>
      {#each allAdsAndDummies as adOrDummy, i}
        <Col>
          <Row class="justify-content-center">
            {#if adOrDummy !== null}
              <div class="Secondary_Action" style="border-color: transparent;">
                <div class="delete-img" on:click={() => {
                  var dt = new Date();
                  dt.setDate( dt.getDate() - 1 );
                  console.log(adOrDummy)
                  changeAnnouncementEndTime(adOrDummy.id, dt)
                }}>X</div>
                <GeneralImg id="{adOrDummy.bucketId}" height="150px"/>
              </div>
            {:else}
              <div class="Secondary_Action" on:click={() => navigateToNewAnnouncement(i)}>
                <img src="static/icons/New_Plus_Sign@2x.png" class="new_group" alt="New Group"/>
              </div>
            {/if}
          </Row>
        </Col>
      {/each}
    </Row>
  </Container>
{:catch error}
  <p>Something went wrong: {error.message}</p>
{/await}
